/**
 * Brand tokens — single source of truth for every app AND every result card.
 * OLED-dark background, soft pink accent. Raw hex so Satori (cards) can use them too.
 * Keep this consistent across all games — the in-feed recognizability is the point.
 */
export const colors = {
  // OLED true-black base so the card pops as rich media in an X timeline.
  bg: "#000000",
  surface: "#0a0a0c",
  surfaceRaised: "#141418",
  border: "#26262c",

  // Soft pink accent — the brand mark.
  accent: "#ff6fa5",
  accentMuted: "#c14e7c",
  accentBright: "#ff9ec6", // lighter pink, e.g. the high end of the gauge gradient
  accentGlow: "rgba(255, 111, 165, 0.35)",

  text: "#f5f5f7",
  textMuted: "#9a9aa3",
  textFaint: "#5c5c66",

  // Leaderboard rank highlights.
  gold: "#ffd45e",
  silver: "#cdd2dc",
  bronze: "#d98f5a",

  // Casino layer: money-green for live value, gold heat for big multipliers,
  // hot red for busts. Glows are the point — value should *radiate*.
  win: "#00e87b",
  winGlow: "rgba(0, 232, 123, 0.35)",
  danger: "#ff3355",
  dangerGlow: "rgba(255, 51, 85, 0.4)",
  goldGlow: "rgba(255, 212, 94, 0.4)",
} as const;

export const fonts = {
  // System stack for the SPA; cards embed an explicit font in Satori.
  sans: 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  mono: 'ui-monospace, "SF Mono", "JetBrains Mono", Menlo, monospace',
  // Odometer-luxe display face for the money numbers (self-hosted woff2 per app).
  display: '"Azeret Mono", ui-monospace, "SF Mono", Menlo, monospace',
} as const;

export const radius = {
  sm: "0.375rem",
  md: "0.75rem",
  lg: "1.25rem",
  full: "9999px",
} as const;

/** Result card is rendered at 2x for crisp PNG; logical size below. */
export const card = {
  width: 1200,
  height: 675, // 16:9, X large-image friendly
} as const;

export const theme = { colors, fonts, radius, card } as const;
export type Theme = typeof theme;
